export default __webpack_public_path__ + "static/wamo-web-pages-53c3487348182cd7ad968fe1483e8901.jpg";